<script lang="ts">
    import Lazy from "svelte-lazy";
    import { afterUpdate, onMount } from "svelte";
    import { page } from "$app/stores";
    import { goto } from "$app/navigation";
    import { getAuthToken } from "$lib/stores/auth";
    import { isPageActive } from "$lib/utils/is-page-active";
    import { ProgressBar } from "@prgm/sveltekit-progress-bar";
    import Footer from "$lib/components/navigation/footer.svelte";
    import Navbar from "$lib/components/navigation/navbar.svelte";
    import SectionNewsCategory from "$lib/components/section/News/section-news-category.svelte";
    import SubscribeSectionCmu from "$lib/components/section/Subcribe/cathmeup/SubscribeSectionCMU.svelte";
    import NewsListPageCategories from "$lib/components/section/News/common/categories/NewsListPageCategories.svelte";
    import NewsListPageCategoriesCMU from "$lib/components/section/News/catchmeup/categories/NewsListPageCategoriesCMU.svelte";

    export let data: any;
    let customPath = data?.customPath;

    let urlPath = ""; // ((window?.location?.pathname?.split('/')?.[2] === 'categories') && window?.location?.pathname?.split('/')?.[3]) ? window?.location?.pathname?.split('/')?.[3] : ''

    afterUpdate(() => {
        const { pathname } = window.location;
        const pathSegments = pathname.split("/");
        if (pathSegments[1] === "news" && pathSegments[2] === "categories") {
            urlPath = pathSegments[3];
        } else {
            urlPath = "";
        }
    });

    $: news = data?.news;
    $: client = data?.client;
    $: categories = data?.categories;
    $: titleName = data?.titleName;
    $: filteredCategories = data?.categories?.find(
        (element: { slug: string }) => {
            const slugParts = element?.slug?.split("-");
            return element?.slug === urlPath;
        },
    );

    let categorySlug = data?.categorySlug;
    let dataClient = data?.client;
    let permissions = data?.permissions;

    const primaryColor = String(data?.permissions?.data?.colors?.primary);

    const currentNamePage = isPageActive("news", dataClient, permissions);

    onMount(async () => {
        let authToken = await getAuthToken();
        if (!authToken && data?.client?.force_user_to_login === 1) {
            goto("/login");
        }
    });
</script>

<svelte:head>
    <title>
        {currentNamePage} ({titleName}) -
        {client?.name}
    </title>
    <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${client?.favicon === null ? "/favicon-32x32.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={`${client?.favicon === null ? "/favicon-96x96.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${client?.favicon === null ? "/favicon-16x16.png" : client?.favicon}`}
    />
</svelte:head>

<Navbar data={client} dataPermission={permissions} {customPath} />
<ProgressBar color={primaryColor} class="text-[${primaryColor}]" zIndex={100} />

{#if client?.code === "catchmeup"}
    <NewsListPageCategoriesCMU
        {currentNamePage}
        {primaryColor}
        {news}
        {categories}
        {client}
    />
    <SubscribeSectionCmu {primaryColor} />
{:else}
    <NewsListPageCategories
        {currentNamePage}
        {primaryColor}
        {news}
        {categories}
        {client}
    />
{/if}

<Footer data={client} />
